export default class ValidarAdeudos {
    constructor(cliente) {
        this.cliente = cliente;
    }

    obtenerEmojiStatus(estado) {
        switch (estado.toLowerCase().trim()) {
            case "activo":
                return "✅";
            case "inactivo":
                return "⚠️";
            case "cerrado":
                return "🔒";
            default:
                return "❓";
        }
    }

    validarAdeudos() {
        const { numero_cuenta, ultima_conexion, MontoPagar, equipo, estado, telefonos, rfc, email } = this.cliente;
        const estadoCliente = estado || "No disponible";
        const emojiStatus = this.obtenerEmojiStatus(estadoCliente);
        const saldo = MontoPagar !== null ? "$" + MontoPagar : "No disponible";
        const adeudo = Number(MontoPagar);

        // Para estado "cerrado"
        if (estadoCliente.toLowerCase().trim() === "cerrado" && (telefonos || rfc || email)) {
            return ('✅ Procede la venta.')

        } else if (estadoCliente.toLowerCase().trim() === "cerrado") {
            const ultimaConexionDate = new Date(ultima_conexion);
            const currentDate = new Date();
            const diffDays = (currentDate - ultimaConexionDate) / (1000 * 3600 * 24);

            if (diffDays >= 366) {
                return (
                    `🔎 Se encontró coincidencia:\n` +
                    `🏦 Número de cuenta: ${numero_cuenta || "No disponible"}\n` +
                    `${emojiStatus} Estado: ${estadoCliente}\n` +
                    `📅 Última desconexión: ${ultima_conexion || "No disponible"}\n` +
                    `💰 Saldo: ${saldo}\n` +
                    `🛅 Equipo: ${equipo || "No disponible"}\n` +
                    `✅ La venta procede. Disponible para activar de nuevo`
                );
            } else if (diffDays >= 181) {
                return (
                    `🔎 Se encontró coincidencia:\n` +
                    `🏦 Número de cuenta: ${numero_cuenta || "No disponible"}\n` +
                    `${emojiStatus} Estado: ${estadoCliente}\n` +
                    `📅 Última desconexión: ${ultima_conexion || "No disponible"}\n` +
                    `💰 Saldo: ${saldo}\n` +
                    `🛅 Equipo: ${equipo || "No disponible"}\n` +
                    `✅ La venta procede si devuelve el equipo (si es que aún cuenta con él). Disponible para activar de nuevo`
                );
            } else {
                return (
                    `🔎 Se encontró coincidencia:\n` +
                    `🏦 Número de cuenta: ${numero_cuenta || "No disponible"}\n` +
                    `${emojiStatus} Estado: ${estadoCliente}\n` +
                    `📅 Última desconexión: ${ultima_conexion || "No disponible"}\n` +
                    `💰 Saldo: ${saldo}\n` +
                    `🛅 Equipo: ${equipo || "No disponible"}\n` +
                    `❌ La venta no procede debido a una conexión reciente.`
                );
            }
        }
        // Para estado "inactivo"
        else if (estadoCliente.toLowerCase().trim() === "inactivo") {
            const ultimaConexionDate = new Date(ultima_conexion);
            const currentDate = new Date();
            const diffDays = (currentDate - ultimaConexionDate) / (1000 * 3600 * 24);

            if (diffDays < 181) { // Última conexión menor a 6 meses y 1 día
                // Definir condiciones: "tiene adeudo" si adeudo !== 0 y "tiene equipo" si existe (y no es "No disponible" o vacío)
                const tieneAdeudo = adeudo !== 0;
                const tieneEquipo = equipo && equipo.trim() !== "" && equipo.toLowerCase() !== "no disponible";

                if (!tieneAdeudo && !tieneEquipo) {
                    return (
                        `🔎 Se encontró coincidencia:\n` +
                        `🏦 Número de cuenta: ${numero_cuenta || "No disponible"}\n` +
                        `${emojiStatus} Estado: ${estadoCliente}\n` +
                        `📅 Última desconexión: ${ultima_conexion || "No disponible"}\n` +
                        `💰 Saldo: ${saldo}\n` +
                        `🛅 Equipo: ${equipo || "No disponible"}\n` +
                        `✅ La venta procede. Disponible para activar de nuevo`
                    );
                } else if (tieneAdeudo && tieneEquipo) {
                    return (
                        `🔎 Se encontró coincidencia:\n` +
                        `🏦 Número de cuenta: ${numero_cuenta || "No disponible"}\n` +
                        `${emojiStatus} Estado: ${estadoCliente}\n` +
                        `📅 Última desconexión: ${ultima_conexion || "No disponible"}\n` +
                        `💰 Saldo: ${saldo}\n` +
                        `🛅 Equipo: ${equipo || "No disponible"}\n` +
                        `❌ La cuenta no procede. Opciones para deslindar:\n` +
                        `   • 1️⃣ Pagar 4 meses por adelantado.\n` +
                        `   • 2️⃣ Entregar los equipos.\n` +
                        `   • 3️⃣ Presentar un comprobante de domicilio a nombre del cliente.\n` +
                        `   • 4️⃣ Contrato de arrendamiento con requisitos fiscales.`
                    );
                } else if (tieneAdeudo && !tieneEquipo) {
                    return `❓ No se como proceder`;
                } else {
                    // Caso adicional (por ejemplo, no tiene adeudo pero sí tiene equipo) – usamos un fallback
                    return (
                        `🔎 Se encontró coincidencia:\n` +
                        `🏦 Número de cuenta: ${numero_cuenta || "No disponible"}\n` +
                        `${emojiStatus} Estado: ${estadoCliente}\n` +
                        `📅 Última desconexión: ${ultima_conexion || "No disponible"}\n` +
                        `💰 Saldo: ${saldo}\n` +
                        `🛅 Equipo: ${equipo || "No disponible"}\n` +
                        `✅ La venta procede. Disponible para activar de nuevo`
                    );
                }
            } else {
                // Si la última conexión es igual o mayor a 6 meses y 1 día, se muestra un mensaje por defecto
                return (
                    `🔎 Se encontró coincidencia:\n` +
                    `🏦 Número de cuenta: ${numero_cuenta || "No disponible"}\n` +
                    `${emojiStatus} Estado: ${estadoCliente}\n` +
                    `📅 Última desconexión: ${ultima_conexion || "No disponible"}\n` +
                    `💰 Saldo: ${saldo}\n` +
                    `🛅 Equipo: ${equipo || "No disponible"}\n` +
                    `✅ La venta procede. Disponible para activar de nuevo`
                );
            }
        }
        // Para estado "activo"
        else if (estadoCliente.toLowerCase().trim() === "activo" && (telefonos || rfc || email)) {
            return ('❌ No procede la venta. El cliente tiene un contrato activo.')
        }else if (adeudo !== 0) {
                return (
                    `🏦 Número de cuenta: ${numero_cuenta || "No disponible"}\n` +
                    `${emojiStatus} Estado: ${estadoCliente}\n` +
                    `📅 Última desconexión: ${ultima_conexion || "No disponible"}\n` +
                    `💰 Saldo: ${MontoPagar !== null ? "$⚠️ Tiene adeudo" : "No disponible"}\n` +
                    `🛅 Equipo: ${equipo || "No disponible"}\n\n`
                );
            } else if (adeudo === 0) {
                return (
                    `🏦 Número de cuenta: ${numero_cuenta || "No disponible"}\n` +
                    `${emojiStatus} Estado: ${estadoCliente}\n` +
                    `📅 Última desconexión: ${ultima_conexion || "No disponible"}\n` +
                    `💰 Saldo: ${MontoPagar !== null ? "$" + MontoPagar : "No disponible"}\n` +
                    `🛅 Equipo: ${equipo || "No disponible"}\n\n`
                );
            }else {
            return "Estado del cliente no reconocido";
        }
    }
}